import React, { useRef } from 'react';
import { contact } from '../data';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_b4e32yg', 'template_75mykkc', form.current, 'pcaMeAWTTdGJzmEMV')
      .then((result) => {
        console.log(result.text);
        Swal.fire({
          text: ` I get your email . I will contact you very soon`,
          icon: 'success',
          confirmButtonText: 'Thank you.'
      })
      }, (error) => {
        console.log(error.text);
      });
    e.target.reset()
  };


  return (
    <section className='section bg-primary' id='contact'>
      <div className='container mx-auto'>
        <div className='flex flex-col items-center text-center'>
          <h2 className='section-title  relative before:absolute before:opacity-40 before:-top-7 before:-left-40 before:hidden before:lg:block'>
            Contact me
          </h2>
          <p className='subtitle'></p>
        </div>
        <div
          className='flex flex-col lg:gap-x-8 lg:flex-row'
        >
          <div
            className='flex flex-1 flex-col items-start space-y-8 mb-12 lg:mb-0 lg:pt-2'
          >
            {contact.map((item, index) => {
              const { icon, title, subtitle, description } = item;
              return (
                <div className='flex flex-col lg:flex-row gap-x-4' key={index}>
                  <div className='text-accent rounded-sm w-14 h-14 flex items-start justify-center mt-2 mb-4 lg:mb-0 text-2xl'>
                    {icon}
                  </div>
                  <div>
                    <h4 className='font-body text-xl mb-1'>{title}</h4>
                    <p className='mb-1 text-paragraph'>{subtitle}</p>
                    <p className='text-accent font-normal '>{description}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <form className='space-y-8 w-full max-w-[780px]' 
            ref={form} onSubmit={sendEmail}
          >
            <div className='flex gap-8'>
              <input className='input' name='name' type='text' placeholder='Your name' required />
              <input className='input' name='email' type='email' placeholder='Your email' required />
            </div>
            <input className='input' type='text' name='subject' placeholder='Subject' required />
            <textarea
              className='textarea'
              name='message'
              placeholder='Your message' required
            ></textarea>
            <button type='submit' className='btn btn-lg bg-accent hover:bg-secondary-hover'>
              Send message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
